/* eslint-disable no-unused-vars */
export enum Role {
  ADM = 'ADMINISTRATOR',
  ENG = 'ENGINEER',
  SUP = 'SUPERVISOR',
  CWR = 'CLIENT_WRITER',
  CRE = 'CLIENT_READER',
  WAD = 'WAREHOUSE_ADMIN',
  LTE = 'LABORATORY_TECHNICIAN',
  DIS = 'DISPATCHER',
  LAD = 'LABORATORY_ADMIN'
}

export const allRoles = Object.values(Role);

/* STATUS */

export enum StatusCode {
  Uploaded = 1,
  PendingAssignment,
  PendingConfirmation,
  AssignedAndConfirmed,
  Closed,
  Travel,
  Working,
  Pending,
  Historic,
  ClosedWithRejection,
  Cancelled,
  Programmed = 14,
  PreAssigned,
  Waiting,
  PendingValidation,
  PendingSupply,
  Scheduled,
  PendingReason,
  ForReceivingPermission,
  ValidatePosition,
  PendingSerie,
  LabDiagnostic,
  PendingForWarehouse,
  HistoricWithRejection,
  RemoteDiagnostic,
  DetentionJuridical,
  ForRecieving,
  DiagnosisAndQuotation,
  QuotationAuthorization,
  PendingRepair,
  PendingTotalLossProcedure,
  InRepair,
  PendingInsurance,
  RejectedByTaskForce,
  ReOpened,
  Reassign,
  RemoteRecovery,
  PendingForReason,
  PendingForSerieRevision = 42,
  PendingForStoreRevision,
  inTransferToLaboratory = 42,
  isLab = 44,
  ScheduledRevision = 44
}

// #region AccessElements
export enum AccessElements {
  AssetsConfirmShipments = 'Assets.ConfirmShipments',
  AssetsKitsSearchExport = 'Assets.KitsSearchExport',
  AssetsLaboratoryProductsSearchExport = 'Assets.LaboratoryProductsSearchExport',
  AssetsSearchShipments = 'Assets.SearchShipments',
  AssetsStateChange = 'Assets.StateChange',
  AssetsSuppliesSearchExport = 'Assets.SuppliesSearchExport',
  AssetsWarehouseKitsSearchExport = 'Assets.WarehouseKitsSearchExport',
  AssetsWarehouseProductsSearchExport = 'Assets.WarehouseProductsSearchExport',
  AssetsWorkForceProductsSearchExport = 'Assets.WorkForceProductsSearchExport',
  AssetsWorkForceSuppliesSearchExport = 'Assets.WarehouseSuppliesSearchExport',
  AuditCreate = 'Audit.Create',
  AuditCreateReport = 'Audit.CreateReport',
  AuditReportSearchGeneral = 'Audit.ReportSearchGeneral',
  AuditSearchGeneral = 'Audit.SearchGeneral',
  BrandCreate = 'Brand.Create',
  BrandDelete = 'Brand.Delete',
  BrandSearchGeneral = 'Brand.SearchGeneral',
  BrandUpdate = 'Brand.Update',
  ClientAddState = 'Client.AddState',
  ClientCreate = 'Client.Create',
  ClientCreateODT = 'Client.CreateODT',
  ClientDelete = 'Client.Delete',
  ClientDeleteODT = 'Client.DeleteODT',
  ClientEnableService = 'Client.EnableService',
  ClientODTSteps = 'Client.ODTSteps',
  ClientSearchExportODT = 'Client.SearchExportODT',
  ClientSearchGeneral = 'Client.SearchGeneral',
  ClientUpdate = 'Client.Update',
  ClientUpdateODT = 'Client.UpdateODT',
  ComponentStatusAdd = 'ComponentStatus.Add',
  ComponentStatusDelete = 'ComponentStatus.Delete',
  ComponentStatusSearch = 'ComponentStatus.Search',
  ComponentStatusUpdate = 'ComponentStatus.Update',
  CurrencyCreate = 'Currency.Create',
  CurrencyDelete = 'Currency.Delete',
  CurrencySearchGeneral = 'Currency.SearchGeneral',
  CurrencyUpdate = 'Currency.Update',
  FlowTypeAdd = 'FlowType.Add',
  FlowTypeDelete = 'FlowType.Delete',
  FlowTypeSearch = 'FlowType.Search',
  FlowTypeUpdate = 'FlowType.Update',
  FrequentFailureCreate = 'FrequentFailure.Create',
  FrequentFailureDelete = 'FrequentFailure.Delete',
  FrequentFailureSearchGeneral = 'FrequentFailure.SearchGeneral',
  FrequentFailureUpdate = 'FrequentFailure.Update',
  InterventionCodeAdd = 'InterventionCode.Add',
  InterventionCodeDelete = 'InterventionCode.Delete',
  InterventionCodeSearch = 'InterventionCode.Search',
  InterventionCodeUpdate = 'InterventionCode.Update',
  KitComponentsUpdate = 'Kit.ComponentsUpdate',
  KitCreate = 'Kit.Create',
  KitDelete = 'Kit.Delete',
  KitLog = 'Kit.Log',
  KitQuery = 'Kit.Query',
  KitUpdate = 'Kit.Update',
  LocationBulkDisable = 'Location.BulkDisable',
  LocationBulkLoad = 'Location.BulkLoad',
  LocationCreate = 'Location.Create',
  LocationDelete = 'Location.Delete',
  LocationGlobalMap = 'Location.GlobalMap',
  LocationLog = 'Location.Log',
  LocationSearch = 'Location.Search',
  LocationSearchAndExport = 'Location.SearchAndExport',
  LocationSearchTickets = 'Location.SearchTickets',
  LocationUpdate = 'Location.Update',
  LocationTaskForceGeolocation = 'Location.TaskForceGeolocation',
  PriorityCreate = 'Priority.Create',
  PriorityDelete = 'Priority.Delete',
  PrioritySearchGeneral = 'Priority.SearchGeneral',
  PriorityUpdate = 'Priority.Update',
  ProductBulkLoad = 'Product.BulkLoad',
  ProductCreate = 'Product.Create',
  ProductDelete = 'Product.Delete',
  ProductLog = 'Product.Log',
  ProductMap = 'Product.Map',
  ProductSelfAssignment = 'Product.SelfAssignment',
  ProductModelCreate = 'ProductModel.Create',
  ProductModelDelete = 'ProductModel.Delete',
  ProductModelSearchGeneral = 'ProductModel.SearchGeneral',
  ProductModelUpdate = 'ProductModel.Update',
  ProductQueryTicket = 'Product.QueryTicket',
  ProductSearchGeneral = 'Product.SearchGeneral',
  ProductUpdateStatus = 'Product.UpdateStatus',
  ProductUpdate = 'Product.Update',
  ProjectAdd = 'Project.Add',
  ProjectDelete = 'Project.Delete',
  ProjectSearch = 'Project.Search',
  ProjectUpdate = 'Project.Update',
  ReasonCreate = 'Reason.Create',
  ReasonDelete = 'Reason.Delete',
  ReasonSearchGeneral = 'Reason.SearchGeneral',
  ReasonUpdate = 'Reason.Update',
  ResponsibleCreateType = 'Responsible.CreateType',
  ResponsibleDeleteType = 'Responsible.DeleteType',
  ResponsibleSearchGeneral = 'Responsible.SearchGeneral',
  ResponsibleUpdateType = 'Responsible.UpdateType',
  SearchActiveReason = 'Ticket.SearchActiveReason',
  SearchFinalizedReason = 'Ticket.SearchFinalizedReason',
  SearchPendingReason = 'Ticket.SearchPendingReason',
  SearchRevisionReason = 'Ticket.SearchRevisionReason',
  ServiceConfiguration = 'Service.Configuration',
  ServiceConfigureMinimumEvidence = 'Service.ConfigureMinimumEvidence',
  ServiceConfigureType = 'Service.ConfigureType',
  ServiceCreate = 'Service.Create',
  ServiceCreateIndicator = 'Service.CreateIndicator',
  ServiceCreateSchedule = 'Service.CreateSchedule',
  ServiceDelete = 'Service.Delete',
  ServiceDeleteSchedule = 'Service.DeleteSchedule',
  ServiceGetSchedule = 'Service.GetSchedule',
  ServiceSearchGeneral = 'Service.SearchGeneral',
  ServiceSearchIndicator = 'Service.SearchIndicator',
  ServiceTypeCreate = 'ServiceType.Create',
  ServiceTypeDelete = 'ServiceType.Delete',
  ServiceTypeSearchGeneral = 'ServiceType.SearchGeneral',
  ServiceTypeUpdate = 'ServiceType.Update',
  ServiceUpdate = 'Service.Update',
  ShipmentCreate = 'Shipment.Create',
  ShipmentDelete = 'Shipment.Delete',
  ShipmentSearchGeneral = 'Shipment.SearchGeneral',
  ShipmentUpdate = 'Shipment.Update',
  SuppliesAdd = 'Supplies.Add',
  SuppliesDelete = 'Supplies.delete',
  SuppliesSearch = 'Supplies.Search',
  SupplyCreate = 'Supply.Create',
  SupplyDelete = 'Supply.Delete',
  SupplySearchGeneral = 'Supply.SearchGeneral',
  SupplyUpdate = 'Supply.Update',
  // Tickets
  TicketAcceptAssignation = 'Ticket.AcceptAssignation',
  TicketAddComment = 'Ticket.AddComment',
  TicketAddFile = 'Ticket.AddFile',
  TicketAddRejectReason = 'Ticket.AddRejectReason',
  TicketAssignation = 'Ticket.Assignation',
  TicketCancelODT = 'Ticket.CancelODT',
  TicketCommentTypeCreate = 'TicketCommentType.Create',
  TicketCommentTypeDelete = 'TicketCommentType.Delete',
  TicketCommentTypeSearchGeneral = 'TicketCommentType.SearchGeneral',
  TicketCommentTypeUpdate = 'TicketCommentType.Update',
  TicketCreate = 'Ticket.Create',
  TicketCreateODT = 'Ticket.CreateODT',
  TicketDeleteFile = 'Ticket.DeleteFile',
  TicketDeleteRejectReason = 'Ticket.DeleteRejectReason',
  TicketDownloadFile = 'Ticket.DownloadFile',
  TicketGetById = 'Ticket.GetById',
  TicketPendingBySerie = 'Ticket.PendingBySerie',
  TicketPendingByWarehouse = 'Ticket.PendingByWarehouse',
  TicketQueryComment = 'Ticket.QueryComment',
  TicketQueryFile = 'Ticket.QueryFile',
  TicketQueryODTDetail = 'Ticket.QueryODTDetail',
  TicketReAssignation = 'Ticket.ReAssignation',
  TicketReject = 'Ticket.Reject',
  TicketRejectAssignation = 'Ticket.RejectAssignation',
  TicketReplication = 'Ticket.Replication',
  TicketSaveMultiTicket = 'Ticket.SaveMultiTicket',
  TicketSearchCanceled = 'Ticket.SearchCanceled',
  TicketSearchGeneral = 'Ticket.SearchGeneral',
  TicketSearchHistorical = 'Ticket.SearchHistorical',
  TicketSearchODT = 'Ticket.SearchODT',
  TicketSearchProgrammed = 'Ticket.SearchProgrammed',
  TicketSearchRejectReason = 'Ticket.SearchRejectReason',
  TicketUpdateRejectReason = 'Ticket.UpdateRejectReason',
  TicketUpdateToCanceledStatus = 'Ticket.UpdateToCanceledStatus',
  TicketUpdateToClosedStatus = 'Ticket.UpdateToClosedStatus',
  TicketUpdateToHistoricStatus = 'Ticket.UpdateToHistoricStatus',
  TicketUpdateToOnSiteStatus = 'Ticket.UpdateToOnSiteStatus',
  TicketUpdateToPendingReasonStatus = 'Ticket.UpdateToPendingReasonStatus',
  TicketUpdateToPendingValidationStatus = 'Ticket.UpdateToPendingValidationStatus',
  TicketUpdateToQuickRecoverStatus = 'Ticket.UpdateToQuickRecoverStatus',
  TicketUpdateToScheduled = 'Ticket.UpdateToScheduled',
  TicketUpdateToTravelStatus = 'Ticket.UpdateToTravelStatus',
  TicketCreateWithPreviousDate = 'Ticket.CreateWithPreviousDate',
  TicketRemoteAssignation = 'Ticket.RemoteAssignation',
  TicketUploadOnPendingValidation = 'Ticket.UploadOnPendingValidation',
  CreateRelatedTicket = 'Ticket.CreateRelatedTicket',
  CreateRelatedServiceTicket = 'Ticket.CreateRelatedServiceRequests',
  CreateTicketReportConfig = 'Ticket.CreateTicketReportConfig',
  //
  ChangeCreate = 'Change.Create',
  ChangeUpdate = 'Change.Update',
  ChangeSearch = 'Change.Search',
  ChangeDelete = 'Change.Delete',
  //
  UsersChangePermissions = 'Users.ChangePermissions',
  UsersClientPermissions = 'Users.ClientPermissions',
  UsersCommentTypePermissions = 'Users.CommentTypePermissions',
  UsersCopyOperationPermissions = 'Users.CopyOperationPermissions',
  UsersCopyPermissions = 'Users.CopyPermissions',
  UsersCreateProfile = 'Users.CreateProfile',
  UsersCreateUser = 'Users.CreateUser',
  UsersDeleteProfile = 'Users.DeleteProfile',
  UsersDeleteUser = 'Users.DeleteUser',
  UsersExportLog = 'Users.ExportLog',
  UsersViewTrackingLog = 'Users.ViewTrackingLog',
  UsersODTPermissions = 'Users.ODTPermissions',
  UsersOperationsPermissions = 'Users.OperationsPermissions',
  UsersResetPassword = 'Users.ResetPassword',
  UsersSearchProfile = 'Users.SearchProfile',
  UsersSearchUser = 'Users.SearchUser',
  UsersServiceTypePermissions = 'Users.ServiceTypePermissions',
  UsersTaskforcePermissions = 'Users.TaskforcePermissions',
  UsersUpdateProfile = 'Users.UpdateProfile',
  UsersUpdateUser = 'Users.UpdateUser',
  UsersWarehousePermissions = 'Users.WarehousePermissions',
  UsersChangePermissionsGroup = 'Users.ChangePermissionsGroup',
  WarehouseAddress = 'Warehouse.Address',
  WarehouseConfiguration = 'Warehouse.Configuration',
  WarehouseCreate = 'Warehouse.Create',
  WarehouseDelete = 'Warehouse.Delete',
  WarehouseSearchGeneral = 'Warehouse.SearchGeneral',
  WarehouseUpdate = 'Warehouse.Update',
  WorkingAreaAddResponsible = 'WorkingArea.AddResponsible',
  WorkingAreaCreate = 'WorkingArea.Create',
  WorkingAreaDelete = 'WorkingArea.Delete',
  WorkingAreaDeleteResponsible = 'WorkingArea.DeleteResponsible',
  WorkingAreaSearchGeneral = 'WorkingArea.SearchGeneral',
  WorkingAreaSearchResponsible = 'WorkingArea.SearchResponsible',
  WorkingAreaUpdate = 'WorkingArea.Update',
  WorkingAreaUpdateResponsible = 'WorkingArea.UpdateResponsible',
  TicketSetDelayClassification = 'Ticket.SetDelayClassification',
  DelayCatalogCreate = 'TicketDelayClassification.Create',
  DelayCatalogUpdate = 'TicketDelayClassification.Update',
  DelayCatalogDelete = 'TicketDelayClassification.Delete',
  DelayCatalogSearch = 'TicketDelayClassification.Search',
  // Catalogos
  CatalogsAddRegion = 'Catalogs.AddRegion',
  CatalogsAddState = 'Catalogs.AddState',
  CatalogsDeleteRegion = 'Catalogs.DeleteRegion',
  CatalogsDeleteState = 'Catalogs.DeleteState',
  CatalogsSearchRegion = 'Catalogs.SearchRegion',
  CatalogsSearchState = 'Catalogs.SearchState',
  CatalogsUpdateRegion = 'Catalogs.UpdateRegion',
  CatalogsUpdateState = 'Catalogs.UpdateState',
  CatalogsAddCP = 'Catalogs.AddCP',
  CatalogsDeleteCP = 'Catalogs.DeleteCP',
  CatalogsUpdateCP = 'Catalogs.UpdateCP',
  CatalogsSearchCP = 'Catalogs.SearchCP',
  CatalogsHolidays = 'Catalogs.HolidayDay',
  // Laboratorio
  LaboratoryProductsSearchExport = 'Assets.LaboratoryProductsSearchExport',
  LaboratoryAceptAndRejectProducts = 'Product.ReceiveComponents',
  LaboratoryAssignProducts = 'Product.MassiveAssignComponents',
  LaboratoryReAssignProducts = 'Product.ReassignComponents',
  ProductAssignRepairedBySupplier = 'Product.AssignRepairedBySupplier',
  // EquipmentType
  EquipmentTypeCreate = 'EquipmentType.Create',
  EquipmentTypeDelete = 'EquipmentType.Delete',
  EquipmentTypeSearch = 'EquipmentType.SearchGeneral',
  EquipmentTypeUpdate = 'EquipmentType.Update',
  // ReparationType
  ReparationTypeCreate = 'ReparationType.Create',
  ReparationTypeDelete = 'ReparationType.Delete',
  ReparationTypeSearch = 'ReparationType.Search',
  ReparationTypeUpdate = 'ReparationType.Update',
  // Audite Type Catalog
  AuditTypeCreate = 'AuditType.Create',
  AuditTypeEdit = 'AuditType.Update',
  AuditTypeDelete = 'AuditType.Delete',
  AuditTypeSearchGeneral = 'AuditType.SearchGeneral',
  // WareHouseType Catalog
  WarehouseTypeSearchGeneral = 'WarehouseType.SearchGeneral',
  WarehouseTypeCreate = 'WarehouseType.Create',
  WarehouseTypeUpdate = 'WarehouseType.Update',
  WarehouseTypeDelete = 'WarehouseType.Delete',
  // Unit of Measurements
  UnitsMeasurementCreate = 'UnitMeasurement.Create',
  UnitsMeasurementDelete = 'UnitMeasurement.Delete',
  UnitsMeasurementSearchGeneral = 'UnitMeasurement.SearchGeneral',
  UnitsMeasurementUpdate = 'UnitMeasurement.Update',
  // Notification Permissions
  NotificationDelete = 'Notification.Delete',
  NotificationSearch = 'Notification.SearchGeneral',
  // FOLIO TAG Permissions
  TagCodeMassiveCreate = 'TagCode.BulkCreate',
  TagCodeCreate = 'TagCode.Create',
  TagCodeGeneralSearch = 'TagCode.SearchGeneral',
  TagCodeDelete = 'TagCode.Delete',
  TagCodeUpdate = 'TagCode.Update',
  // FOLIO COMBUSTIBLE permisos
  FuelCodeCreate = 'FuelCode.Create',
  FuelCodeBulkCreate = 'FuelCode.BulkCreate',
  FuelCodeUpdate = 'FuelCode.Update',
  FuelCodeDelete = 'FuelCode.Delete',
  FuelCodeSearchGeneral = 'FuelCode.SearchGeneral',
  // FOLIO VIATICO Permissions
  ExpenseCodeCreate = 'ExpenseCode.Create',
  ExpenseCodeBulkCreate = 'ExpenseCode.BulkCreate',
  ExpenseCodeUpdate = 'ExpenseCode.Update',
  ExpenseCodeDelete = 'ExpenseCode.Delete',
  ExpenseCodeSearchGeneral = 'ExpenseCode.SearchGeneral',
  // Report Catalogue Perms
  GenerateDashboardGeneralSearch = 'GeneratedReport.SearchGeneral',
  DashboardCreate = 'Dashboard.Create',
  DashboardDelete = 'Dashboard.Delete',
  DashboardScopeClient = 'Dashboard.Scope.Client',
  DashboardScopeColombia = 'Dashboard.Scope.Colombia',
  DashboardScopeMexico = 'Dashboard.Scope.Mexico',
  DashboardSearchGeneral = 'Dashboard.SearchGeneral',
  DashboardUpdate = 'Dashboard.Update',
  DashboardGetByUpToDate = 'Dashboard.GetByUpToDate',
  DashboardGetByStatus = 'Dashboard.GetByStatus',
  DashboardGetByClient = 'Dashboard.GetByClient',
  DashboardOpenIncidents = 'Dashboard.OpenIncidents',
  DashboardHistoricalIncidents = 'Dashboard.HistoricalIncidents',
  DashboardShowReportsDashboars = 'Dashboard.ShowReportsDashboards',
  DashboardShowReportsCost = 'Dashboard.ShowReportCostServices',
  DashboardShowReportRemoteWork = 'Dashboard.ShowReportRemoteWork',
  // Tickets Reports
  TicketReportGeneralSearch = 'Ticket.SearchGeneratedReport',
  // Escalations
  EscalationTypeGet = 'EscalationType.Get',
  EscalationCreate = 'Escalation.Create',
  EscalationUpdate = 'Escalation.Update',
  EscalationDelete = 'Escalation.Delete',
  EscalationGet = 'Escalation.Get',
  EscalationSearch = 'Escalation.Search',
  // KPI
  KPIManagement = 'KPI.KPIManagement',
  SurveyManagement = 'Survey.SurveyManagement',
  SurveyDelete = 'Survey.Delete',
  SurveyUpdate = 'Survey.Update',
  SurveySearch = 'Survey.Search',
  SurveyReport = 'Survey.Report',
  FormsFormManagement = 'Forms.FormsManagement',
  CatalogShowNotificationCatalog = 'Catalog.ShowNotificationCatalog',
  CatalogShowTicketStatus = 'Catalog.ShowTicketStatus',
  CatalogShowTicketFlow = 'Catalog.ShowTicketFlow',
  // Clase de servicio Admin
  ServiceClassCreate = 'Catalog.CreateServiceClass',
  ServiceClassDelete = 'Catalog.DeleteServiceClass',
  ServiceClassSearch = 'Catalog.SearchServiceClass',
  ServiceClassUpdate = 'Catalog.UpdateServiceClass',
  // Process
  ChangeAdvisoryBoardCreate = 'ChangeAdvisoryBoard.Create',
  ChangeAdvisoryBoardDelete = 'ChangeAdvisoryBoard.Delete',
  ChangeAdvisoryBoardUpdate = 'ChangeAdvisoryBoard.Update',
  ChangeAdvisoryBoardSearch = 'ChangeAdvisoryBoard.Search',
  // Change Stage and Status
  ChangeStageStatusSearchGeneral = 'ChangeStageStatus.SearchGeneral',
  ChangeStageStatusDelete = 'ChangeStageStatus.Delete',
  ChangeStageStatusUpdate = 'ChangeStageStatus.Update',
  ChangeStageStatusCreate = 'ChangeStageStatus.Create',
  // Change Stages
  ChangeStageSearchGeneral = 'ChangeStage.SearchGeneral',
  ChangeStageDelete = 'ChangeStage.Delete',
  ChangeStageUpdate = 'ChangeStage.Update',
  ChangeStageCreate = 'ChangeStage.Create',
  // Change flow
  ChangeFlowCreate = 'ChangeFlow.Create',
  ChangeFlowDelete = 'ChangeFlow.Delete',
  ChangeFlowUpdate = 'ChangeFlow.Update',
  ChangeFlowSearch = 'ChangeFlow.Search',
  // Change types
  ChangeTypeCreate = 'ChangeType.Create',
  ChangeTypeDelete = 'ChangeType.Delete',
  ChangeTypeUpdate = 'ChangeType.Update',
  ChangeTypeSearch = 'ChangeType.Search',
  // Task admin
  TaskAddFile = 'Task.AddFile',
  TaskDeleteFile = 'Task.DeleteFile',
  TaskDownloadFile = 'Task.DownloadFile',
  TaskQueryFile = 'Task.QueryFile',
  TaskSearchGeneral = 'Task.SearchGeneral',
  TaskCreate = 'Task.Create',
  TaskGetById = 'Task.GetById',
  TaskUpdate = 'Task.Update',
  TaskDelete = 'Task.Delete',
  // Approvals
  AddMember = 'Approvals.AddMember',
  SendApproval = 'Approvals.SendApproval',
  Approve = 'Approvals.Approve',
  SearchApprovals = 'Approvals.Search',
  GetApprovals = 'Approvals.Get',
  // Problems
  ProblemCreate = 'Problem.Create',
  ProblemUpdate = 'Problem.Update',
  ProblemDelete = 'Problem.Delete',
  ProblemSearch = 'Problem.Search',
  ProblemAddFile = 'Problem.AddFile',
  ProblemDeleteFile = 'Problem.DeleteFile',
  ProblemQueryFile = 'Problem.QueryFile',

  TicketStatusAdd = 'TicketStatus.Create',
  TicketStatusDelete = 'TicketStatus.Delete',
  TicketStatusSearch = 'TicketStatus.Search',
  TicketStatusUpdate = 'TicketStatus.Update',

  CategoryCreate = 'Category.Create',
  CategoryDelete = 'Category.Delete',
  CategoryUpdate = 'Category.Update',
  CategorySearch = 'Category.Search',

  ImpactCreate = 'Impact.Create',
  ImpactDelete = 'Impact.Delete',
  ImpactUpdate = 'Impact.Update',
  ImpactSearch = 'Impact.Search',

  UrgencyCreate = 'Urgency.Create',
  UrgencyDelete = 'Urgency.Delete',
  UrgencyUpdate = 'Urgency.Update',
  UrgencySearch = 'Urgency.Search',

  TicketPriorityCreate = 'TicketPriority.Create',
  TicketPriorityDelete = 'TicketPriority.Delete',
  TicketPriorityUpdate = 'TicketPriority.Update',
  TicketPrioritySearch = 'TicketPriority.Search',

  AssignmentPriorityCreate = 'AssignmentPriority.Create',
  AssignmentPriorityDelete = 'AssignmentPriority.Delete',
  AssignmentPriorityUpdate = 'AssignmentPriority.Update',
  AssignmentPrioritySearch = 'AssignmentPriority.Search',
  /** Solutions */
  SolutionSearchGeneral = 'Solution.SearchGeneral',
  SolutionCreate = 'Solution.Create',
  SolutionUpdate = 'Solution.Update',
  SolutionDelete = 'Solution.Delete',
  SolutionAddFile = 'Solution.AddFile',
  SolutionDeleteFile = 'Solution.DeleteFile',
  SolutionDownloadFile = 'Solution.DownloadFile',
  SolutionQueryFile = 'Solution.QueryFile',

  CatalogSearchTowerType = 'Catalog.SearchTowerType',
  TowerTypeCreate = 'TowerType.Create',
  TowerTypeUpdate = 'TowerType.Update',
  TowerTypeDelete = 'TowerType.Delete',
  CatalogSearchTowerModel = 'Catalog.SearchTowerModel',
  TowerModelCreate = 'TowerModel.Create',
  TowerModelUpdate = 'TowerModel.Update',
  TowerModelDelete = 'TowerModel.Delete',
  // TowerSearchGeneral = 'Tower.SearchGeneral',
  TowerCreate = 'Tower.Create',
  TowerUpdate = 'Tower.Update',
  // TowerDelete = 'Tower.Delete',
  TowerView = 'Tower.View',
  TowerResponsible = 'Tower.Responsible',
  TowerEditFile = 'Tower.EditFile',

  TowerUploadDocument = 'Tower.UploadDocument',
  TowerDeleteFile = 'Tower.DeleteFile',
  TowerQueryFile = 'Tower.QueryFile',
  TowerLog = 'Tower.Log',
  TowerPropertyCreate = 'TowerProperty.Create',
  TowerPropertyUpdate = 'TowerProperty.Update',
  TowerPropertyDelete = 'TowerProperty.Delete',
  CatalogSearchTowerProperty = 'Catalog.SearchTowerProperty'
}

export enum ProductStatus {
  InRevision = 'En revisión técnica',
  PendingForPart = 'Pendiente por parte',
  Repaired = 'Reparado - Envío Almacén',
  ShippedToSupplier = 'Envio a proveedor',
  Recycling = 'Reciclaje',
  Scrap = 'Scrap',
  RepairedBySupplier = 'Reparado por proveedor'
}

export enum TransitionTypes {
  ServiceAutomaticClose = 1,
  RemoteWork
}

export enum ProductStatusId {
  PendingForPart = 31,
  Repaired = 32,
  ShippedToSupplier = 33,
  Recycling = 34,
  Scrap = 41,
  RejectedByLaboratory = 43,
  Available = 1,
  OnReview = 8,
  InRevision = 45,
  RepairedBySupplier = 46,
  OnLaboratory = 44,
  SendToLaboratory = 27,
  TransferToLaboratory = 42,
  WorkTool = 47,
  IrreparableCustomerOwned = 48
}

export enum NotificationKey {
  TicketReviewPendingSerie = 'Ticket.ReviewPendingSerie',
  ReviewPendingWarehouse = 'Ticket.ReviewPendingWarehouse',
  ReviewScheduled = 'Ticket.ReviewScheduled',
  Survey = 'Survey.Send',
  UserRoleChanged = 'User.RoleChanged'
}

// #region AccessElements Enum
export const accessElementsArray = [
  AccessElements.TicketCreate,
  AccessElements.TicketSearchGeneral,
  AccessElements.TicketGetById,
  AccessElements.TicketUpdateToHistoricStatus,
  AccessElements.TicketUpdateToCanceledStatus,
  AccessElements.TicketUpdateToPendingValidationStatus,
  AccessElements.TicketSaveMultiTicket,
  AccessElements.TicketAcceptAssignation,
  AccessElements.TicketRejectAssignation,
  AccessElements.TicketUpdateToTravelStatus,
  AccessElements.TicketCreateWithPreviousDate,
  AccessElements.TicketRemoteAssignation,
  AccessElements.TicketUploadOnPendingValidation,
  AccessElements.TicketUpdateToOnSiteStatus,
  AccessElements.TicketUpdateToClosedStatus,
  AccessElements.TicketUpdateToQuickRecoverStatus,
  AccessElements.TicketUpdateToPendingReasonStatus,
  AccessElements.TicketReplication,
  AccessElements.TicketSearchHistorical,
  AccessElements.TicketSearchCanceled,
  AccessElements.TicketAssignation,
  AccessElements.TicketReject,
  AccessElements.TicketReAssignation,
  AccessElements.ClientCreate,
  AccessElements.ClientUpdate,
  AccessElements.ClientDelete,
  AccessElements.ClientSearchGeneral,
  AccessElements.ResponsibleSearchGeneral,
  AccessElements.ServiceCreate,
  AccessElements.ServiceUpdate,
  AccessElements.ServiceDelete,
  AccessElements.ServiceSearchGeneral,
  AccessElements.ServiceConfiguration,
  AccessElements.ServiceCreateSchedule,
  AccessElements.ServiceGetSchedule,
  AccessElements.ServiceDeleteSchedule,
  AccessElements.ServiceCreateIndicator,
  AccessElements.ServiceSearchIndicator,
  AccessElements.ServiceConfigureType,
  AccessElements.ServiceConfigureMinimumEvidence,
  AccessElements.ProductCreate,
  AccessElements.ProductUpdate,
  AccessElements.ProductDelete,
  AccessElements.ProductSearchGeneral,
  AccessElements.BrandCreate,
  AccessElements.BrandUpdate,
  AccessElements.BrandDelete,
  AccessElements.BrandSearchGeneral,
  AccessElements.CurrencyCreate,
  AccessElements.CurrencyUpdate,
  AccessElements.CurrencyDelete,
  AccessElements.CurrencySearchGeneral,
  AccessElements.FrequentFailureCreate,
  AccessElements.FrequentFailureUpdate,
  AccessElements.FrequentFailureDelete,
  AccessElements.FrequentFailureSearchGeneral,
  AccessElements.PriorityCreate,
  AccessElements.PriorityUpdate,
  AccessElements.PriorityDelete,
  AccessElements.PrioritySearchGeneral,
  AccessElements.ProductModelCreate,
  AccessElements.ProductSelfAssignment,
  AccessElements.ProductModelUpdate,
  AccessElements.ProductModelDelete,
  AccessElements.ProductModelSearchGeneral,
  AccessElements.ReasonCreate,
  AccessElements.ReasonUpdate,
  AccessElements.ReasonDelete,
  AccessElements.ReasonSearchGeneral,
  AccessElements.ServiceTypeCreate,
  AccessElements.ServiceTypeUpdate,
  AccessElements.ServiceTypeDelete,
  AccessElements.ServiceTypeSearchGeneral,
  AccessElements.TicketCommentTypeCreate,
  AccessElements.TicketCommentTypeUpdate,
  AccessElements.TicketCommentTypeDelete,
  AccessElements.TicketCommentTypeSearchGeneral,
  AccessElements.WorkingAreaCreate,
  AccessElements.WorkingAreaUpdate,
  AccessElements.WorkingAreaDelete,
  AccessElements.WorkingAreaSearchGeneral,
  AccessElements.TicketSetDelayClassification,
  AccessElements.DelayCatalogCreate,
  AccessElements.DelayCatalogUpdate,
  AccessElements.DelayCatalogDelete,
  AccessElements.ShipmentCreate,
  AccessElements.ShipmentUpdate,
  AccessElements.ShipmentDelete,
  AccessElements.ShipmentSearchGeneral,
  AccessElements.SupplyCreate,
  AccessElements.SupplyUpdate,
  AccessElements.SupplyDelete,
  AccessElements.SupplySearchGeneral,
  AccessElements.WarehouseCreate,
  AccessElements.WarehouseUpdate,
  AccessElements.WarehouseDelete,
  AccessElements.WarehouseSearchGeneral,
  AccessElements.WarehouseTypeSearchGeneral,
  AccessElements.ClientAddState,
  AccessElements.ClientCreateODT,
  AccessElements.ClientDeleteODT,
  AccessElements.ClientEnableService,
  AccessElements.ClientODTSteps,
  AccessElements.ClientSearchExportODT,
  AccessElements.ClientUpdateODT,
  AccessElements.ComponentStatusAdd,
  AccessElements.ComponentStatusDelete,
  AccessElements.ComponentStatusSearch,
  AccessElements.ComponentStatusUpdate,
  AccessElements.FlowTypeAdd,
  AccessElements.FlowTypeDelete,
  AccessElements.FlowTypeSearch,
  AccessElements.FlowTypeUpdate,
  AccessElements.InterventionCodeAdd,
  AccessElements.InterventionCodeDelete,
  AccessElements.InterventionCodeSearch,
  AccessElements.InterventionCodeUpdate,
  AccessElements.LocationBulkDisable,
  AccessElements.LocationBulkLoad,
  AccessElements.LocationCreate,
  AccessElements.LocationDelete,
  AccessElements.LocationGlobalMap,
  AccessElements.LocationLog,
  AccessElements.LocationSearch,
  AccessElements.LocationSearchAndExport,
  AccessElements.LocationSearchTickets,
  AccessElements.LocationUpdate,
  AccessElements.LocationTaskForceGeolocation,
  AccessElements.ProductBulkLoad,
  AccessElements.ProductLog,
  AccessElements.ProductMap,
  AccessElements.ProductQueryTicket,
  AccessElements.ProjectAdd,
  AccessElements.ProjectDelete,
  AccessElements.ProjectSearch,
  AccessElements.ProjectUpdate,
  AccessElements.ResponsibleCreateType,
  AccessElements.ResponsibleDeleteType,
  AccessElements.ResponsibleUpdateType,
  AccessElements.TicketAddComment,
  AccessElements.TicketAddFile,
  AccessElements.TicketAddRejectReason,
  AccessElements.TicketCancelODT,
  AccessElements.TicketCreateODT,
  AccessElements.TicketDeleteFile,
  AccessElements.TicketDeleteRejectReason,
  AccessElements.TicketDownloadFile,
  AccessElements.TicketQueryComment,
  AccessElements.TicketQueryFile,
  AccessElements.TicketQueryODTDetail,
  AccessElements.TicketSearchODT,
  AccessElements.TicketSearchProgrammed,
  AccessElements.TicketSearchRejectReason,
  AccessElements.TicketUpdateRejectReason,
  AccessElements.CreateRelatedTicket,
  AccessElements.CreateRelatedServiceTicket,
  AccessElements.UsersChangePermissions,
  AccessElements.UsersClientPermissions,
  AccessElements.UsersCommentTypePermissions,
  AccessElements.UsersCopyOperationPermissions,
  AccessElements.UsersCopyPermissions,
  AccessElements.UsersCreateProfile,
  AccessElements.UsersCreateUser,
  AccessElements.UsersDeleteProfile,
  AccessElements.UsersDeleteUser,
  AccessElements.UsersExportLog,
  AccessElements.UsersViewTrackingLog,
  AccessElements.UsersODTPermissions,
  AccessElements.UsersOperationsPermissions,
  AccessElements.UsersResetPassword,
  AccessElements.UsersSearchProfile,
  AccessElements.UsersSearchUser,
  AccessElements.UsersServiceTypePermissions,
  AccessElements.UsersTaskforcePermissions,
  AccessElements.UsersUpdateProfile,
  AccessElements.UsersUpdateUser,
  AccessElements.UsersWarehousePermissions,
  AccessElements.WarehouseAddress,
  AccessElements.WarehouseConfiguration,
  AccessElements.WorkingAreaAddResponsible,
  AccessElements.WorkingAreaDeleteResponsible,
  AccessElements.WorkingAreaSearchResponsible,
  AccessElements.WorkingAreaUpdateResponsible,
  AccessElements.SuppliesAdd,
  AccessElements.SuppliesDelete,
  AccessElements.SuppliesSearch,
  AccessElements.KitComponentsUpdate,
  AccessElements.KitCreate,
  AccessElements.KitDelete,
  AccessElements.KitLog,
  AccessElements.KitQuery,
  AccessElements.KitUpdate,
  AccessElements.AssetsConfirmShipments,
  AccessElements.AssetsSearchShipments,
  AccessElements.AssetsStateChange,
  AccessElements.AssetsKitsSearchExport,
  AccessElements.AssetsSuppliesSearchExport,
  AccessElements.AssetsWarehouseKitsSearchExport,
  AccessElements.AssetsWarehouseProductsSearchExport,
  AccessElements.AssetsWorkForceSuppliesSearchExport,
  AccessElements.TicketUpdateToScheduled,
  AccessElements.TicketPendingByWarehouse,
  AccessElements.TicketPendingBySerie,
  AccessElements.AssetsWorkForceProductsSearchExport,
  // Catalogos
  AccessElements.CatalogsAddRegion,
  AccessElements.CatalogsAddState,
  AccessElements.CatalogsDeleteRegion,
  AccessElements.CatalogsDeleteState,
  AccessElements.CatalogsSearchRegion,
  AccessElements.CatalogsSearchState,
  AccessElements.CatalogsUpdateRegion,
  AccessElements.CatalogsUpdateState,
  AccessElements.CatalogsAddCP,
  AccessElements.CatalogsDeleteCP,
  AccessElements.CatalogsUpdateCP,
  AccessElements.CatalogsSearchCP,
  // EquipmentType
  AccessElements.EquipmentTypeCreate,
  AccessElements.EquipmentTypeDelete,
  AccessElements.EquipmentTypeSearch,
  AccessElements.EquipmentTypeUpdate,
  // ReparationType
  AccessElements.ReparationTypeCreate,
  AccessElements.ReparationTypeDelete,
  AccessElements.ReparationTypeSearch,
  AccessElements.ReparationTypeUpdate,
  // LABORATORY TECHNICIAN
  AccessElements.AssetsLaboratoryProductsSearchExport,
  AccessElements.ProductUpdateStatus,
  // LABORATORY ADMIN
  AccessElements.LaboratoryAceptAndRejectProducts,
  AccessElements.LaboratoryAssignProducts,
  AccessElements.LaboratoryReAssignProducts,
  AccessElements.ProductAssignRepairedBySupplier,
  // AUDIT
  AccessElements.AuditCreate,
  AccessElements.AuditCreateReport,
  AccessElements.AuditReportSearchGeneral,
  AccessElements.AuditSearchGeneral,
  // UnitsMeasurement
  AccessElements.UnitsMeasurementCreate,
  AccessElements.UnitsMeasurementDelete,
  AccessElements.UnitsMeasurementSearchGeneral,
  AccessElements.UnitsMeasurementUpdate,
  // WareHouseType Catalog
  AccessElements.WarehouseTypeSearchGeneral,
  AccessElements.WarehouseTypeCreate,
  AccessElements.WarehouseTypeUpdate,
  AccessElements.WarehouseTypeDelete,
  // Ticket Filter Permition
  AccessElements.SearchRevisionReason,
  AccessElements.SearchFinalizedReason,
  // Notification Permissions
  AccessElements.NotificationDelete,
  AccessElements.NotificationSearch,
  // FOLIO TAG Permissions
  AccessElements.TagCodeMassiveCreate,
  AccessElements.TagCodeCreate,
  AccessElements.TagCodeGeneralSearch,
  AccessElements.TagCodeDelete,
  AccessElements.TagCodeUpdate,
  // FOLIO COMBUSTIBLE permisos
  AccessElements.FuelCodeCreate,
  AccessElements.FuelCodeBulkCreate,
  AccessElements.FuelCodeUpdate,
  AccessElements.FuelCodeDelete,
  AccessElements.FuelCodeSearchGeneral,
  // FOLIO VIATICOS Permissions
  AccessElements.ExpenseCodeCreate,
  AccessElements.ExpenseCodeBulkCreate,
  AccessElements.ExpenseCodeUpdate,
  AccessElements.ExpenseCodeDelete,
  AccessElements.ExpenseCodeSearchGeneral,
  // Report Catalogue Perms
  AccessElements.GenerateDashboardGeneralSearch,
  AccessElements.DashboardCreate,
  AccessElements.DashboardDelete,
  AccessElements.DashboardScopeClient,
  AccessElements.DashboardScopeColombia,
  AccessElements.DashboardScopeMexico,
  AccessElements.DashboardSearchGeneral,
  AccessElements.DashboardUpdate,
  AccessElements.DashboardGetByUpToDate,
  AccessElements.DashboardGetByStatus,
  AccessElements.DashboardGetByClient,
  AccessElements.DashboardOpenIncidents,
  AccessElements.DashboardHistoricalIncidents,
  AccessElements.DashboardShowReportsDashboars,
  AccessElements.DashboardShowReportsCost,
  // Tickets Reports
  AccessElements.TicketReportGeneralSearch,
  AccessElements.SurveyManagement,
  AccessElements.SurveyDelete,
  AccessElements.SurveyUpdate,
  AccessElements.SurveySearch,
  AccessElements.SurveyReport,
  // Service Class Admin
  AccessElements.ServiceClassCreate,
  AccessElements.ServiceClassDelete,
  AccessElements.ServiceClassSearch,
  AccessElements.ServiceClassUpdate,
  // Process | Changes
  AccessElements.ChangeAdvisoryBoardCreate,
  AccessElements.ChangeAdvisoryBoardDelete,
  AccessElements.ChangeAdvisoryBoardUpdate,
  AccessElements.ChangeAdvisoryBoardSearch,
  // Change Stage and Status
  AccessElements.ChangeStageStatusSearchGeneral,
  AccessElements.ChangeStageStatusDelete,
  AccessElements.ChangeStageStatusUpdate,
  AccessElements.ChangeStageStatusCreate,
  // Change Stages
  AccessElements.ChangeStageSearchGeneral,
  AccessElements.ChangeStageDelete,
  AccessElements.ChangeStageUpdate,
  AccessElements.ChangeStageCreate,
  // Approvals
  AccessElements.AddMember,
  AccessElements.SendApproval,
  AccessElements.Approve,
  AccessElements.SearchApprovals,
  AccessElements.GetApprovals,
  // Problems
  AccessElements.ProblemCreate,
  AccessElements.ProblemUpdate,
  AccessElements.ProblemDelete,
  AccessElements.ProblemSearch,
  AccessElements.ProblemAddFile,
  AccessElements.ProblemDeleteFile,
  AccessElements.ProblemQueryFile,
  // Ticket Status
  AccessElements.TicketStatusAdd,
  AccessElements.TicketStatusDelete,
  AccessElements.TicketStatusSearch,
  AccessElements.TicketStatusUpdate,
  // Category
  AccessElements.CategoryCreate,
  AccessElements.CategoryDelete,
  AccessElements.CategoryUpdate,
  // Impact
  AccessElements.ImpactCreate,
  AccessElements.ImpactDelete,
  AccessElements.ImpactUpdate,
  // Urgency
  AccessElements.UrgencyCreate,
  AccessElements.UrgencyDelete,
  AccessElements.UrgencyUpdate,
  // Ticket Priority
  AccessElements.TicketPriorityCreate,
  AccessElements.TicketPriorityDelete,
  AccessElements.TicketPriorityUpdate,
  // Assignment Priority
  AccessElements.AssignmentPriorityCreate,
  // solutions
  AccessElements.SolutionSearchGeneral,
  AccessElements.SolutionCreate,
  AccessElements.SolutionUpdate,
  AccessElements.SolutionDelete,
  AccessElements.SolutionAddFile,
  AccessElements.SolutionDeleteFile,
  AccessElements.SolutionDownloadFile,
  AccessElements.SolutionQueryFile,
  // Tower
  AccessElements.TowerTypeCreate,
  AccessElements.TowerTypeUpdate,
  AccessElements.TowerTypeDelete,
  // AccessElements.TowerSearchGeneral,
  AccessElements.TowerCreate,
  AccessElements.TowerUpdate,
  // AccessElements.TowerDelete,
  AccessElements.TowerView,
  AccessElements.TowerResponsible,
  AccessElements.TowerEditFile,
  AccessElements.TowerUploadDocument,
  AccessElements.TowerDeleteFile,
  AccessElements.TowerQueryFile,
  AccessElements.TowerLog,
  AccessElements.TowerModelCreate,
  AccessElements.TowerModelUpdate,
  AccessElements.TowerModelDelete,
  AccessElements.CatalogSearchTowerModel,
  AccessElements.CatalogSearchTowerType,
  AccessElements.TowerPropertyCreate,
  AccessElements.TowerPropertyUpdate,
  AccessElements.TowerPropertyDelete,
  AccessElements.CatalogSearchTowerProperty
];

export type StatusItem = {
  id?: number;
  name: string;
  color?: string;
  enabled: boolean;
  ganttColor?: string;
  permission?: AccessElements[];
};

export const Status: {
  [key: number]: StatusItem;
} = {
  [StatusCode.Uploaded]: {
    name: 'ticket.ticketStatus.uploaded',
    enabled: false
  },
  [StatusCode.PendingAssignment]: {
    name: 'ticket.ticketStatus.pendingAssignment',
    color: '#B0B0B0',
    ganttColor: '#edbad1',
    enabled: true
  },
  [StatusCode.PendingConfirmation]: {
    name: 'ticket.ticketStatus.pendingConfirmation',
    color: '#4A4B4B',
    ganttColor: '#edbad1',
    enabled: true
  },
  [StatusCode.AssignedAndConfirmed]: {
    name: 'ticket.ticketStatus.assignedAndConfirmed',
    color: '#04A828',
    ganttColor: '#d5f72d',
    enabled: true
  },
  [StatusCode.Closed]: {
    name: 'ticket.ticketStatus.closed',
    color: '#F77A00',
    ganttColor: '#336ca5',
    enabled: true
  },
  [StatusCode.Travel]: {
    name: 'ticket.ticketStatus.travel',
    color: '#FFD600',
    enabled: true
  },
  [StatusCode.Working]: {
    name: 'ticket.ticketStatus.working',
    color: '#FBB800',
    ganttColor: '#81a319',
    enabled: true
  },
  [StatusCode.Pending]: {
    name: 'ticket.ticketStatus.pending',
    enabled: false
  },
  [StatusCode.Historic]: {
    name: 'ticket.ticketStatus.historic',
    color: '#07163D',
    ganttColor: '#98c0f6',
    enabled: true
  },
  [StatusCode.ClosedWithRejection]: {
    name: 'ticket.ticketStatus.closedWithRejection',
    enabled: false
  },
  [StatusCode.Cancelled]: {
    name: 'ticket.ticketStatus.cancelled',
    color: '#CA296D',
    ganttColor: '#fef2c9',
    enabled: true
  },
  [StatusCode.Programmed]: {
    name: 'ticket.ticketStatus.programmed',
    enabled: true,
    permission: [AccessElements.TicketSearchProgrammed]
  },
  [StatusCode.PreAssigned]: {
    name: 'ticket.ticketStatus.preAssigned',
    enabled: false
  },
  [StatusCode.Waiting]: {
    name: 'ticket.ticketStatus.waiting',
    enabled: false
  },
  [StatusCode.PendingValidation]: {
    name: 'ticket.ticketStatus.pendingValidation',
    color: '#398A12',
    ganttColor: '#edbad1',
    enabled: true
  },
  [StatusCode.PendingSupply]: {
    name: 'ticket.ticketStatus.pendingSupply',
    enabled: false
  },
  [StatusCode.Scheduled]: {
    name: 'ticket.ticketStatus.scheduled',
    ganttColor: '#fefda6',
    enabled: true
  },
  [StatusCode.PendingReason]: {
    name: 'ticket.ticketStatus.pendingReason',
    ganttColor: '#edbad1',
    enabled: true
  },
  [StatusCode.ForReceivingPermission]: {
    name: 'ticket.ticketStatus.forReceivingPermission',
    enabled: false
  },
  [StatusCode.ValidatePosition]: {
    name: 'ticket.ticketStatus.validatePosition',
    enabled: false
  },
  [StatusCode.PendingSerie]: {
    name: 'ticket.ticketStatus.pendingSerie',
    ganttColor: '#edbad1',
    enabled: true
  },
  [StatusCode.LabDiagnostic]: {
    name: 'ticket.ticketStatus.labDiagnostic',
    enabled: false
  },
  [StatusCode.PendingForWarehouse]: {
    name: 'ticket.ticketStatus.pendingForWarehouse',
    ganttColor: '#edbad1',
    enabled: true
  },
  [StatusCode.HistoricWithRejection]: {
    name: 'ticket.ticketStatus.historicWithRejection',
    enabled: false
  },
  [StatusCode.RemoteDiagnostic]: {
    name: 'ticket.ticketStatus.remoteDiagnostic',
    enabled: false
  },
  [StatusCode.DetentionJuridical]: {
    name: 'ticket.ticketStatus.detentionJuridical',
    enabled: false
  },
  [StatusCode.ForRecieving]: {
    name: 'ticket.ticketStatus.forRecieving',
    enabled: false
  },
  [StatusCode.DiagnosisAndQuotation]: {
    name: 'ticket.ticketStatus.diagnosisAndQuotation',
    enabled: false
  },
  [StatusCode.QuotationAuthorization]: {
    name: 'ticket.ticketStatus.quotationAuthorization',
    enabled: false
  },
  [StatusCode.PendingRepair]: {
    name: 'ticket.ticketStatus.pendingRepair',
    enabled: false
  },
  [StatusCode.PendingTotalLossProcedure]: {
    name: 'ticket.ticketStatus.pendingTotalLossProcedure',
    enabled: false
  },
  [StatusCode.InRepair]: {
    name: 'ticket.ticketStatus.inRepair',
    enabled: false
  },
  [StatusCode.PendingInsurance]: {
    name: 'ticket.ticketStatus.pendingInsurance',
    enabled: false
  },
  [StatusCode.RejectedByTaskForce]: {
    name: 'ticket.ticketStatus.rejectedByTaskForce',
    color: '#CB14E9',
    enabled: true
  },
  [StatusCode.ReOpened]: {
    name: 'ticket.ticketStatus.reopened',
    ganttColor: '#CB14E9',
    color: '#D61264',
    enabled: true
  },
  [StatusCode.Reassign]: {
    name: 'ticket.ticketStatus.reassign',
    enabled: true
  },
  [StatusCode.RemoteRecovery]: {
    name: 'ticket.ticketStatus.remoteRecovery',
    ganttColor: '#ff9e8e',
    enabled: true
  },
  [StatusCode.PendingForSerieRevision]: {
    name: 'ticket.ticketStatus.pendingForSerieRevision',
    ganttColor: '#fff0f6',
    enabled: true
  },
  [StatusCode.PendingForStoreRevision]: {
    name: 'ticket.ticketStatus.pendingForStoreRevision',
    ganttColor: '#fff0f6',
    enabled: true
  },
  [StatusCode.ScheduledRevision]: {
    name: 'ticket.ticketStatus.scheduledRevision',
    ganttColor: '#fefda6',
    enabled: true
  }
};

export const statusSelectOptions = (
  Object.keys(Status) as unknown as StatusCode[]
)
  .filter((key) => Status[key].enabled)
  .map((key) => ({
    label: Status[key].name,
    id: Number(key),
    permission: Status[key].permission || []
  }));

function objectKeys<Obj extends object>(obj: Obj): (keyof Obj)[] {
  return Object.keys(obj) as (keyof Obj)[];
}

export const allStatusCodes = objectKeys(Status).filter(
  (key) => Status[key].enabled
);

export const activeStatusCodes = objectKeys(Status).filter(
  (k) =>
    Status[k].enabled &&
    `${k}` !== `${StatusCode.Cancelled}` &&
    `${k}` !== `${StatusCode.Historic}` &&
    `${k}` !== `${StatusCode.Programmed}`
);

/* Comment types */

export enum CommentType {
  Information = 1,
  Cancel,
  StandBy,
  PendingValidation,
  Deactivate,
  PendingReason,
  Scheduled,
  ProgressandServiceSolution
}

/* Shipment status */

export enum ShipmentStatus {
  Pending = 1,
  OnProcess = 2,
  WaitingForDeparture = 3,
  Closed = 4,
  Canceled = 5,
  Confirmed = 6,
  Received = 7
}

export const ShipmentStatusList: {
  [key: number]: {
    name: string;
    enabled: boolean;
  };
} = {
  [ShipmentStatus.Pending]: {
    name: 'Pendiente',
    enabled: true
  },
  [ShipmentStatus.OnProcess]: {
    name: 'En proceso',
    enabled: true
  },
  [ShipmentStatus.WaitingForDeparture]: {
    name: 'Esperando salida',
    enabled: true
  },
  [ShipmentStatus.Closed]: {
    name: 'Cerrado',
    enabled: true
  },
  [ShipmentStatus.Canceled]: {
    name: 'Cancelado',
    enabled: true
  },
  [ShipmentStatus.Confirmed]: {
    name: 'Confirmado',
    enabled: true
  },
  [ShipmentStatus.Received]: {
    name: 'Recibido',
    enabled: true
  }
};

export const shipmentStatusOptions = (
  Object.keys(ShipmentStatusList) as unknown as ShipmentStatus[]
)
  .filter((k) => ShipmentStatusList[k].enabled)
  .map((k) => ({ label: ShipmentStatusList[k].name, id: Number(k) }));

export enum ODTStatus {
  Process = 1,
  Closed,
  Canceled
}

enum TextOption {
  /** Ticket */
  Folio = 'common.commonProperties.ticketNumber',
  TicketStatus = 'common.commonProperties.ticketStatus',
  WorkForce = 'common.commonProperties.taskForce',
  Client = 'common.commonProperties.client',
  Service = 'common.commonProperties.serviceSingular',
  Location = 'common.commonProperties.ubication',
  ODT = 'ODT',
  /** Shimpent */
  ShipmentId = 'common.commonProperties.invoice',
  ShipmentState = 'common.commonProperties.status',
  DestinationResponsible = 'shipment.newShipment.destination',
  DestinationResponsibleType = 'shipment.shippingConfirmation.destinyType',
  OriginResponsible = 'shipment.newShipment.origin',
  OriginResponsibleType = 'shipment.shippingConfirmation.originType',
  Courier = 'shipment.shippingConfirmation.courier',
  GuideNumber = 'shipment.shippingConfirmation.guideNumber',
  Supply = 'common.commonProperties.supplies',
  Component = 'common.commonProperties.configurationComponents',
  Kit = 'common.commonProperties.CIkits',
  /* Shipment Report */
  ShipmentReportId = 'shipment.shippingReport.filter.shipmentId',
  OriginAndDestinationResponsible = 'shipment.shippingReport.filter.originAndDestination',
  ResponsableOrigingAndDestiny = 'shipment.shippingReport.filter.responsableOrigingAndDestiny',
  /** Configuration Components */
  ProductId = 'configurationComponent.headers.id',
  ResponsibleName = 'configurationComponent.headers.responsible',
  ResponsibleTypeName = 'configurationComponent.headers.responsibleType',
  LocationName = 'configurationComponent.headers.location',
  ProductStatusName = 'configurationComponent.headers.componentStatus',
  ProductBrandName = 'configurationComponent.headers.brand',
  ProductModelName = 'configurationComponent.headers.model',
  ProductModelDescription = 'configurationComponent.headers.description',
  ProductConditionName = 'configurationComponent.headers.condition',
  SerialNumber = 'configurationComponent.headers.serialNumber',
  KitName = 'configurationComponent.headers.ciKit',
  /* Reporte de Costos */
  ubication = 'costReport.columns.ubication',
  ticketId = 'costReport.columns.ticketID',
  serviceName = 'costReport.columns.serviceName',
  serviceClass = 'costReport.columns.serviceClass',
  /* Problems */
  ProblemId = 'common.commonProperties.id',
  ProblemTitle = 'problems.columns.title',
  ProblemRequester = 'problems.columns.technician',
  ProblemCategory = 'common.commonProperties.categoryActive',
  ProblemPriority = 'common.commonProperties.priorityActive',
  ProblemStatus = 'common.commonProperties.status',
  ProblemUrgency = 'common.commonProperties.urgency',
  /* Changes */
  ChangeId = 'common.commonProperties.changeId',
  ChangeTitle = 'common.commonProperties.nameChange',
  ChangeType = 'common.commonProperties.typeChange',
  ChangeStage = 'common.commonProperties.stageChange',
  ChangeStatus = 'common.commonProperties.stateChange'
}

enum TextTypeTicketIds {
  Folio = 1,
  TicketStatus,
  WorkForce,
  Client,
  Service,
  Location,
  ODT
}

enum TextTypeShipmentIds {
  ShipmentId = 1,
  SerialNumber,
  Supply,
  Kit,
  DestinationResponsible,
  ShipmentState,
  OriginResponsible,
  OriginResponsibleType,
  DestinationResponsibleType,
  Courier,
  GuideNumber
}

export enum TextTypeConfigComponentIds {
  ProductId = 1,
  ResponsibleName,
  ResponsibleTypeName,
  LocationName,
  ProductStatusName,
  ProductBrandName,
  ProductModelName,
  ProductModelDescription,
  ProductConditionName,
  SerialNumber,
  KitName
}

enum TextTypeCostReport {
  ticketId = 1,
  ubication,
  serviceName,
  serviceClass
}

enum TextTypeOptions {
  ProblemId = 1,
  Title,
  ProblemRequester,
  ProblemCategory,
  ProblemPriority,
  ProblemStatus,
  ProblemUrgency
}

enum TextTypeChanges {
  ChangeId = 1,
  Title = 2,
  ChangeType = 3,
  ChangeStage = 4,
  ChangeStatus = 5
}

export const TextTypesOptions = {
  ticket: [
    { label: TextOption.Folio, id: TextTypeTicketIds.Folio },
    { label: TextOption.TicketStatus, id: TextTypeTicketIds.TicketStatus },
    { label: TextOption.WorkForce, id: TextTypeTicketIds.WorkForce },
    { label: TextOption.Client, id: TextTypeTicketIds.Client },
    { label: TextOption.Service, id: TextTypeTicketIds.Service },
    { label: TextOption.Location, id: TextTypeTicketIds.Location },
    { label: TextOption.ODT, id: TextTypeTicketIds.ODT }
  ],
  shipment: [
    { label: TextOption.ShipmentId, id: TextTypeShipmentIds.ShipmentId },
    { label: TextOption.ShipmentState, id: TextTypeShipmentIds.ShipmentState },
    {
      label: TextOption.OriginResponsible,
      id: TextTypeShipmentIds.OriginResponsible
    },
    {
      label: TextOption.DestinationResponsible,
      id: TextTypeShipmentIds.DestinationResponsible
    },
    {
      label: TextOption.OriginResponsibleType,
      id: TextTypeShipmentIds.OriginResponsibleType
    },
    {
      label: TextOption.DestinationResponsibleType,
      id: TextTypeShipmentIds.DestinationResponsibleType
    },
    {
      label: TextOption.Kit,
      id: TextTypeShipmentIds.Kit
    },
    {
      label: TextOption.Component,
      id: TextTypeShipmentIds.SerialNumber
    },
    {
      label: TextOption.Supply,
      id: TextTypeShipmentIds.Supply
    },
    { label: TextOption.Courier, id: TextTypeShipmentIds.Courier },
    { label: TextOption.GuideNumber, id: TextTypeShipmentIds.GuideNumber }
  ],
  shipmentReport: [
    { label: TextOption.ShipmentId, id: TextTypeShipmentIds.ShipmentId },
    { label: TextOption.ShipmentState, id: TextTypeShipmentIds.ShipmentState },
    {
      label: TextOption.OriginResponsible,
      id: TextTypeShipmentIds.OriginResponsible
    },
    {
      label: TextOption.DestinationResponsible,
      id: TextTypeShipmentIds.DestinationResponsible
    }
  ],
  configComponents: [
    { label: TextOption.ProductId, id: TextTypeConfigComponentIds.ProductId },
    {
      label: TextOption.ResponsibleName,
      id: TextTypeConfigComponentIds.ResponsibleName
    },
    {
      label: TextOption.ResponsibleTypeName,
      id: TextTypeConfigComponentIds.ResponsibleTypeName
    },
    {
      label: TextOption.LocationName,
      id: TextTypeConfigComponentIds.LocationName
    },
    {
      label: TextOption.ProductStatusName,
      id: TextTypeConfigComponentIds.ProductStatusName
    },
    {
      label: TextOption.ProductBrandName,
      id: TextTypeConfigComponentIds.ProductBrandName
    },
    {
      label: TextOption.ProductModelName,
      id: TextTypeConfigComponentIds.ProductModelName
    },
    {
      label: TextOption.ProductModelDescription,
      id: TextTypeConfigComponentIds.ProductModelDescription
    },
    {
      label: TextOption.ProductConditionName,
      id: TextTypeConfigComponentIds.ProductConditionName
    },
    {
      label: TextOption.SerialNumber,
      id: TextTypeConfigComponentIds.SerialNumber
    },
    { label: TextOption.KitName, id: TextTypeConfigComponentIds.KitName }
  ],
  costReport: [
    { label: TextOption.ticketId, id: TextTypeCostReport.ticketId },
    { label: TextOption.ubication, id: TextTypeCostReport.ubication },
    { label: TextOption.serviceName, id: TextTypeCostReport.serviceName },
    { label: TextOption.serviceClass, id: TextTypeCostReport.serviceClass }
  ],
  problems: [
    { label: TextOption.ProblemId, id: TextTypeOptions.ProblemId },
    { label: TextOption.ProblemTitle, id: TextTypeOptions.Title },
    {
      label: TextOption.ProblemRequester,
      id: TextTypeOptions.ProblemRequester
    },
    {
      label: TextOption.ProblemCategory,
      id: TextTypeOptions.ProblemCategory
    },
    {
      label: TextOption.ProblemPriority,
      id: TextTypeOptions.ProblemPriority
    },
    {
      label: TextOption.ProblemStatus,
      id: TextTypeOptions.ProblemStatus
    },
    {
      label: TextOption.ProblemUrgency,
      id: TextTypeOptions.ProblemUrgency
    }
  ],
  changes: [
    { label: TextOption.ChangeId, id: TextTypeChanges.ChangeId },
    { label: TextOption.ChangeTitle, id: TextTypeChanges.Title },
    { label: TextOption.ChangeType, id: TextTypeChanges.ChangeType },
    { label: TextOption.ChangeStage, id: TextTypeChanges.ChangeStage },
    { label: TextOption.ChangeStatus, id: TextTypeChanges.ChangeStatus }
  ]
};
